import { CompanyInterface } from 'client/Interfaces/CompanyInterface'

export const shouldSeeSuperNavigation = (company: CompanyInterface): boolean => {
  // Do not remove checks for undefined value for company as it might be not loaded after login
  return company?.uiSetup === 'supernav_invoicing_accounting'
}
